module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'recordController'
	],

	config: {
		entityContext: 'artFormAddress',		// entityContext (address, trip, activity)
		scope: 'art_form',
		privilegeBase: 'artform_addresses',
		entityPropertiesFormComponentClass: 'templates_artForm_entity_propertiesForm',
		showTripNavButton: false,
		showCooperationNavButton: false,
		showDetailsNavButton: false,
		entityIsDeletable: false,
		preventDeletions: false
	},

	model: {
		parentEntityID: false,
	}
}